import { Component } from '@angular/core';

import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../base.menu';

@Component({
    templateUrl: './edit-observation.menu.html',
    standalone: false
})
export class EditObservationMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
    this.modal.hasClassModal = true;
  }
}
